'use client';

import { useMemo, useState } from 'react';
import { Bar, BarChart, CartesianGrid, Cell, XAxis, YAxis } from 'recharts';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { CHART_COLORS, ChatChartData } from './ChatChartComponent';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../ui/card';
import { Button } from '../../../ui/button';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '../../../ui/chart';
import ChatChartTablePreview from './ChatChartTablePreview';


interface BarChartProps {
    chartData: ChatChartData;
}

export const ChatBarChartComponent = ({ chartData }: BarChartProps) => {
    const [showMetadata, setShowMetadata] = useState(false);
    const { meta, data } = chartData;


    const { title, yAxisKey, xAxisName, bars, xAxisKey } = useMemo(() => {


        const yAxisKey = meta?.y_axis_label ?? meta?.yAxis?.dataKey ?? meta?.y_axis?.dataKey ?? meta?.y_axis?.data_key ?? meta?.y_axis?.name ?? '';
        const xAxisKey = meta?.xAxis?.dataKey ?? meta?.x_axis?.dataKey ?? meta?.x_axis?.data_key ?? '';
        const yAxisName = meta?.y_axis_label ?? meta?.yAxis?.name ?? meta?.y_axis?.name ?? '';
        const xAxisName = meta?.x_axis_label ?? meta?.xAxis?.name ?? meta?.x_axis?.name ?? meta?.x_axis?.dataKey ?? meta?.x_axis?.data_key ?? '';
        const title = meta?.title ?? `${xAxisName ?? ''} vs ${yAxisName ?? ''}`;
        const bars = meta?.bars ?? [];

        return {
            title,
            yAxisKey,
            xAxisName, xAxisKey,
            yAxisName,
            bars,
        };
    }, [chartData]);

    if (!yAxisKey || !xAxisName) {
        return <div>Missing axis configuration for BarChart</div>;
    }

    // const xAxisKey = meta.xAxis.dataKey

    const margin = meta?.margin || { top: 20, right: 30, left: 20, bottom: 5 };

    // const chartConfig = {
    //     [yAxisKey]: {
    //         label: yAxisName,
    //         color: CHART_COLORS[2],
    //     },
    // };

    const chartConfig = useMemo(() => {
        const config: Record<string, { label: string; color: string }> = {}

        bars.forEach((bar, index) => {
            // Use the custom color based on index (with fallback to first color if more bars than colors)
            const colorIndex = index % CHART_COLORS.length
            config[bar.data_key] = {
                label: bar.name,
                color: CHART_COLORS[colorIndex],
            }
        })

        return config
    }, [bars])

    return (
        <Card className="w-full shadow-md hover:shadow-lg transition-shadow duration-300">
            <CardHeader className="flex flex-row items-center justify-between">
                <div>
                    <CardTitle>Bar Chart</CardTitle>
                    <CardDescription>
                        {title}
                    </CardDescription>
                </div>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => setShowMetadata(!showMetadata)}
                    aria-label={showMetadata ? 'Hide data table' : 'Show data table'}
                >
                    {showMetadata ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
                </Button>
            </CardHeader>
            <CardContent>
                <ChartContainer config={chartConfig} className="min-h-[400px]">
                    <BarChart data={data} margin={margin}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                            dataKey={xAxisKey ?? xAxisName}
                            // tickFormatter={formatXAxisLabel}
                            angle={-30}
                            textAnchor="end"
                            height={150}
                            tickMargin={20}
                        />
                        <YAxis
                            // tickFormatter={formatValue}
                            width={100}
                            allowDecimals={false}
                            axisLine={true}
                            tickLine={true}
                            scale="auto"
                            domain={["auto", "auto"]}
                            padding={{ top: 10, bottom: 0 }}
                        />
                        <ChartTooltip content={<ChartTooltipContent  />} />
                        {bars.map((bar, index) => {
                            // Use the custom color based on index (with fallback to first color if more bars than colors)
                            const colorIndex = index % CHART_COLORS.length
                            return (
                                <Bar
                                    key={bar.data_key}
                                    dataKey={bar.data_key}
                                    fill={CHART_COLORS[colorIndex]}
                                    radius={[4, 4, 0, 0]}
                                    name={bar.name}
                                >
                                    {data.map((entry: any, index: number) => (
                                        <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                                    ))}
                                </Bar>
                            )
                        })}
                    </BarChart>
                    {/*<BarChart data={data} margin={margin}>*/}
                    {/*    <CartesianGrid strokeDasharray="3 3" />*/}
                    {/*    <XAxis dataKey={xAxisKey ?? xAxisName}*/}
                    {/*           label={{ value: xAxisName, position: 'insideBottom', offset: -5 }} />*/}
                    {/*    <YAxis label={{ value: yAxisName, angle: -90, position: 'insideLeft' }} />*/}
                    {/*    <ChartTooltip content={<ChartTooltipContent />} />*/}
                    {/*    /!*<Bar dataKey={yAxisKey} fill={CHART_COLORS[2]} radius={4}>*!/*/}
                    {/*    /!*    {data.map((_: any, index:number) => (*!/*/}
                    {/*    /!*        <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />*!/*/}
                    {/*    /!*    ))}*!/*/}
                    {/*    /!*</Bar>*!/*/}

                    {/*    {*/}
                    {/*        bars.map((bar: {*/}
                    {/*            dataKey: string | undefined;*/}
                    {/*            data_key: string | undefined;*/}
                    {/*            name: string;*/}
                    {/*        }, index: number) => (*/}
                    {/*            <Bar*/}
                    {/*                key={bar.dataKey as string || bar.data_key as string}*/}
                    {/*                dataKey={bar.dataKey as string || bar.data_key as string}*/}
                    {/*                name={bar.name}*/}
                    {/*                radius={[4, 4, 0, 0]}*/}
                    {/*                fill={CHART_COLORS[index % CHART_COLORS.length]}*/}

                    {/*            >*/}
                    {/*                {data.map((entry: any, index:number) => (*/}
                    {/*                    <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />*/}
                    {/*                ))}*/}
                    {/*            </Bar>*/}
                    {/*        ))*/}
                    {/*    }*/}
                    {/*</BarChart>*/}
                </ChartContainer>

                <ChatChartTablePreview closeTable={() => {
                    setShowMetadata(false);
                }} showTable={showMetadata} data={data} />
            </CardContent>
        </Card>
    );
};

